<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 200px;}
.count .el-input__inner {width: 50px;}
.el-checkbox {margin-right: 0px;}
.el-checkbox__inner {border-radius: 50%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;margin-bottom: 40px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-form ref="form" :model="form">
        <table class="dmkclb">
          <tr class="tr tr1">
            <td>
                <div class="td">
                  <el-button type="success" v-if="parms === 'FirInfo'" @click="addfn()">添加</el-button>
                </div>
            </td>
          </tr>
        </table>
      </el-form>
      <div class="el-tablebox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          stripe
          border
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{background: '#F5F5F5',color: '#606266',textAlign: 'center'}">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="title" label="标题"> </el-table-column>
          <el-table-column label="图片" >
              <template slot-scope="scope">
              <img :src="scope.row.thumb" width="100px" height="100px" class="head_pic"/>
            </template>
          </el-table-column>
           <el-table-column label="添加时间" width="250">
            <template slot-scope="scope">{{ (scope.row.addtime * 1000) | formatTime() }}</template>
          </el-table-column>
          <el-table-column prop="id" label="排序" width="180">
            <template slot-scope="scope">
              <el-button @click="setup(scope.row)">上移</el-button>
              <el-button @click="setdown(scope.row)">下移</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="warning" @click="updatafn(scope.row)">修改</el-button>
              <el-button type="danger" @click="deletefn(11, 112, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button class="elbtn delete" @click="deletesfn(11, 112)">批量删除</el-button>
      </div>
    </div>
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * lx
 * 矿业论坛会议后台列表页
 */
import filters from '../method/filter'
import {mapState} from 'vuex'
export default {
  mixins: [filters],
  data()
  {
    return {
      form: {
        title: '',
        count: 10
      },
      pageSize: 10,
      currentPage: 1,
      countSum: null,
      //分类数据
      classifydata: [],
      //列表数据
      tableData: [],
      newsInfo: [],
      parms: ''
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      IsLb: state => state.kyltMid
    })
  },
  watch:
  {
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
          this.getList()
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    this.urlpath = window.location.href
    this.parms = this.urlpath.substring(this.urlpath.lastIndexOf('/') + 1)
    this.getList()
  },
  methods: {
    //获取数据
    getList()
    {
      let count = this.form.count
      let currentPage = this.currentPage
      let exp = ''
      //循环筛选条件
      for (let e in this.form)
      {
        let item = this.form[e]
        if (item && e === 'title')
          exp += `name like '%${item}%' and `
      }
      exp = exp ? `${exp}id != 0` : 'id > 0'
      let paras = {cmd: 'query', _major: 11, _minor: 112, _exp: exp, init: 0, pageno: `${currentPage}`, pagesize: `${count}`, orderby: 'orders DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        if (ret.length !== 0)
        {
          this.countSum = ret[0].total
          this.tableData = []
          ret[0].data.forEach((item) =>
          {
            this.tableData.push({
              id: item.id,
              title: item.title,
              thumb: item.thumb.split(',')[0],
              addtime: item.addtime,
              orders: item.orders
            })
          })
        }
      })
    },
    // 点击上移
    setup(row)
    {
      if (row.orders === 1)

        this.$message({message: '此条数据已是第一位，不能再次上移', type: 'error', customClass: 'mzindex'})
      else
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 112,
          _exp: 'orders=?',
          types: 'i',
          vals: row.orders + 1
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length > 0)
          {
            let obj = {
              cmd: 'updateAtt',
              _major: 11,
              _minor: 112,
              retAtt: 1,
              id: ret[0].id,
              orders: ret[0].orders - 1
            }
            window.post.getPost(obj)
            let objs = {
              cmd: 'updateAtt',
              _major: 11,
              _minor: 112,
              retAtt: 1,
              id: row.id,
              orders: row.orders + 1
            }
            window.post.getPost(objs).then((retss) =>
            {
              if (retss)
              {
                this.$message({message: '上移成功', type: 'success', customClass: 'mzindex'})
                this.getList()
              }
            })
          }
        })
      }
    },
    // 点击下移
    setdown(row)
    {
      if (row.orders === this.countSum)

        this.$message({message: '此条数据已是最后一位，不能再次下移', type: 'error', customClass: 'mzindex'})
      else
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 112,
          _exp: 'orders=?',
          types: 'i',
          vals: row.orders - 1
        }
        window.post.getPost(paras).then((ret) =>
        {
          if (ret.length > 0)
          {
            let obj = {
              cmd: 'updateAtt',
              _major: 11,
              _minor: 112,
              retAtt: 1,
              id: ret[0].id,
              orders: ret[0].orders + 1
            }
            window.post.getPost(obj)
            let objs = {
              cmd: 'updateAtt',
              _major: 11,
              _minor: 112,
              retAtt: 1,
              id: row.id,
              orders: row.orders - 1
            }
            window.post.getPost(objs).then((retss) =>
            {
              if (retss)
              {
                this.$message({message: '下移成功', type: 'success', customClass: 'mzindex'})
                this.getList()
              }
            })
          }
        })
      }
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/FirPhotoUpdate', query: {id: row.id}})
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      if (row.orders === that.countSum)
      
        window.public.deletefn(major, minor, row, that)
      
      {
        let paras = {
          cmd: 'query',
          _major: 11,
          _minor: 112,
          _exp: 'orders > ?',
          types: 'i',
          vals: row.orders,
          orderby: 'orders DESC'
        }
        window.post.getPost(paras).then((ret) =>
        {
          let dataId = []
          let dataOrders = []
          ret.forEach(item =>
          {
            dataId.push(item.id)
            dataOrders.push(`${item.orders - 1}`)
          })
          let objcontent = {
            cmd: 'updateAtts',
            _major: 11,
            _minor: 112,
            retAtt: 1,
            separator: ',',
            ids: dataId.toString(),
            orders: dataOrders.toString()
          }
          window.post.getPost(objcontent).then((res) =>
          {
            if (res.ret === 0)
              window.public.deletefn(major, minor, row, that)
          })
        })
      }
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.$emit('addTab3')
    },
    //————列表页的公共方法————
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/FirPhotoLB.vue